<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1100px" scrollable>
    <v-card>
      <v-card-title class="py-3">
        <span class="headline">Potvrda o plaći (R-1)</span>
        <v-spacer></v-spacer>
        <span class="subtitle-1">{{ imeRadnika }}</span>
      </v-card-title>
      <v-card-text style="max-height: 78vh;">
        <v-row dense align="center">
          <v-col cols="12" sm="4" md="3">
            <v-text-field
              v-model="mjesec"
              type="month"
              label="Mjesec nastanka slučaja"
              hint="Mjesec u kojem počinje bolovanje na teret HZZO-a"
              persistent-hint
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="8" md="9">
            <span v-if="f">
              Razdoblje:
              <b>{{ f.razdobljeOd }}</b> do <b>{{ f.razdobljeDo }}</b>
              (razdoblje isplate)
            </span>
          </v-col>
        </v-row>

        <v-progress-linear v-if="ucitavam" indeterminate class="mb-2"></v-progress-linear>
        <v-alert v-if="greska" type="error" dense text class="mt-2">{{ greska }}</v-alert>

        <template v-if="f">
          <v-alert v-for="(u, i) in upozorenja" :key="'u' + i" type="warning" dense text class="mt-1 mb-1">{{ u }}</v-alert>

          <div class="naslov-kartice mt-3">Poslodavac</div>
          <v-row dense>
            <v-col cols="12" md="9">
              <v-text-field v-model="f.poslodavac" label="Naziv poslodavca (adresa, OIB)" dense></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="f.brojObveze" label="Broj obveze (HZZO)" hint="nije u bazi - upiši ručno" persistent-hint dense></v-text-field>
            </v-col>
          </v-row>

          <div class="naslov-kartice mt-3">1. Podaci o osiguraniku</div>
          <v-row dense>
            <v-col cols="12" sm="6" md="3"><v-text-field v-model="f.prezime" label="Prezime" dense></v-text-field></v-col>
            <v-col cols="12" sm="6" md="3"><v-text-field v-model="f.ime" label="Ime" dense></v-text-field></v-col>
            <v-col cols="12" sm="6" md="3"><v-text-field v-model="f.datumRodenja" label="Datum rođenja (dd.mm.gggg.)" dense></v-text-field></v-col>
            <v-col cols="12" sm="6" md="3"><v-text-field v-model="f.oib" label="OIB" dense></v-text-field></v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="f.mbo"
                label="MBO"
                :hint="f.mbo ? '' : 'MBO nije upisan kod radnika - upiši ručno'"
                persistent-hint
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="9">
              <v-radio-group v-model="f.drugiStup" row dense hide-details class="mt-0">
                <template v-slot:label><span>Osiguranik II. stupa mirovinskog osiguranja:</span></template>
                <v-radio label="da" value="da"></v-radio>
                <v-radio label="ne" value="ne"></v-radio>
                <v-radio label="bez oznake" value=""></v-radio>
              </v-radio-group>
              <div class="caption grey--text text--darken-1">Predloženo prema doprinosu za II. stup na obračunima; provjeri.</div>
            </v-col>
          </v-row>

          <div class="naslov-kartice mt-3">2. Iznosi plaće po mjesecima</div>
          <v-row dense>
            <v-col cols="6" sm="3" md="2"><v-text-field v-model="f.razdobljeOd" label="Razdoblje od" dense></v-text-field></v-col>
            <v-col cols="6" sm="3" md="2"><v-text-field v-model="f.razdobljeDo" label="Razdoblje do" dense></v-text-field></v-col>
          </v-row>
          <div style="overflow-x: auto;">
            <table class="r1-tablica">
              <thead>
                <tr>
                  <th>Mjesec (1)</th>
                  <th>Plaća bruto (2)</th>
                  <th>Isplaćena neto (3)</th>
                  <th>Sati rad puno, uklj. GO i druge plaćene odsutnosti (4)</th>
                  <th>Sati duže od punog (5)</th>
                  <th>Odsutnost ZOR - samo bolovanje (6)</th>
                  <th>Ukupno sati (7)</th>
                  <th>PN na teret Zavoda (8)</th>
                  <th>Sati po kalendaru = stupac 7 (9)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in f.redci" :key="i">
                  <td v-for="k in KOLONE" :key="k">
                    <input
                      v-model="r[k]"
                      :class="{lijevo: k === 'mjesec'}"
                      :placeholder="k === 'mjesec' ? r.oznaka : ''"
                      @input="preracunaj(k)"
                    />
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td><b>Ukupno</b></td>
                  <td class="ukupno">{{ f.ukupno.placa }}</td>
                  <td class="ukupno">{{ f.ukupno.isplacena }}</td>
                  <td class="ukupno">{{ f.ukupno.satiPuno }}</td>
                  <td class="ukupno">{{ f.ukupno.satiDuze }}</td>
                  <td class="ukupno">{{ f.ukupno.satiOdsutnost }}</td>
                  <td class="ukupno">{{ f.ukupno.satiUkupno }}</td>
                  <td class="ukupno">{{ f.ukupno.satiPN }}</td>
                  <td class="ukupno">{{ f.ukupno.satiKalendar }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="caption grey--text text--darken-1 mt-1">
            Razdoblje je razdoblje isplate: obračun za mjesec M isplaćuje se u M+1; stupac 1 sadrži mjesece za koje je plaća obračunata (šest mjeseci prije mjeseca slučaja).
            Mjesec bez isplate ostaje bez oznake mjeseca (upute: upisuju se samo mjeseci s isplaćenom plaćom). Ukupno se računa iz redaka.
            Stupac 7 = 4 + 5 + 6; stupac 9 se prepisuje iz stupca 7; sati PN na teret Zavoda (8) nisu u stupcu 7.
            Pretpostavka: godišnji odmor, plaćeni dopust, neradni blagdan, tjedni odmor i zastoj krivnjom poslodavca
            ubrojeni su u stupac 4 (rad), a u stupcu 6 je samo bolovanje na teret poslodavca. Po potrebi ispravi.
          </div>

          <div class="naslov-kartice mt-3">3. Osnovica (eura po satu)</div>
          <v-row dense>
            <v-col cols="6" sm="4" md="3">
              <v-text-field v-model="f.brutoPoSatu" label="Bruto po satu (2 : 7)" dense></v-text-field>
            </v-col>
            <v-col cols="6" sm="4" md="3">
              <v-text-field v-model="f.netoPoSatu" label="Neto po satu (3 : 7)" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-btn text small color="primary" @click="preracunajSatnicu">Preračunaj iz ukupno</v-btn>
            </v-col>
          </v-row>

          <div class="naslov-kartice mt-3">Mjesto, datum, ovlaštena osoba</div>
          <v-row dense>
            <v-col cols="12" sm="4" md="3"><v-text-field v-model="f.mjesto" label="Mjesto" dense></v-text-field></v-col>
            <v-col cols="12" sm="4" md="3"><v-text-field v-model="f.datum" label="Datum (dd.mm.gggg.)" dense></v-text-field></v-col>
            <v-col cols="12" sm="4" md="6"><v-text-field v-model="f.ovlastenaOsoba" label="Ime i prezime / OIB ovlaštene osobe" dense></v-text-field></v-col>
          </v-row>

          <div class="naslov-kartice mt-3">Evidencijski list o izvršenim isplatama (stranica 2)</div>
          <v-row dense align="center">
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="mjesecIsplate"
                type="month"
                label="Mjesec isplate"
                hint="Obračunski mjesec za predpopunjavanje sati bolovanja"
                persistent-hint
                dense
                @change="ucitaj(true)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="8" md="9" class="caption grey--text text--darken-1">
              <span v-if="info && info.imaObracun">
                U obračunu za {{ info.mjesecIsplate.oznaka }}: sati bolovanja na teret Zavoda {{ info.satiZavod }},
                na teret poslodavca {{ info.satiPoslodavac }}.
                <span v-if="info.postoUObracunu">Postotak u obračunu: {{ info.postoUObracunu }} %.</span>
              </span>
              <span v-else>Za odabrani mjesec nema obračuna radnika.</span>
              Datumi bolovanja nisu u bazi - upiši ih ručno.
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="3"><v-text-field v-model="f.evidencija.datumPocetka" label="Datum početka PN po dijagnozi" dense></v-text-field></v-col>
            <v-col cols="6" sm="4" md="2"><v-text-field v-model="f.evidencija.prviDan" label="Prvi dan PN" dense></v-text-field></v-col>
            <v-col cols="6" sm="4" md="2"><v-text-field v-model="f.evidencija.posljednjiDan" label="Posljednji dan PN" dense></v-text-field></v-col>
            <v-col cols="8" sm="6" md="3"><v-text-field v-model="f.evidencija.brojEvidencije" label="Broj evidencije prijave ozljede/bolesti" dense></v-text-field></v-col>
            <v-col cols="4" sm="6" md="2">
              <v-select v-model="f.evidencija.vrstaPN" :items="['PN', 'TJO', '']" label="PN / TJO" dense></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="8" sm="6" md="3"><v-text-field v-model="f.evidencija.brojOzljede" label="Evid. broj priznate ozljede/prof. bolesti" dense></v-text-field></v-col>
            <v-col cols="4" sm="6" md="2">
              <v-select v-model="f.evidencija.vrstaOzljede" :items="['OR', 'PB', '']" label="OR / PB" dense></v-select>
            </v-col>
            <v-col cols="12" sm="8" md="5">
              <v-select
                v-model="f.evidencija.oznaka"
                :items="OZNAKE"
                item-text="tekst"
                item-value="oznaka"
                label="Evidencijska oznaka uzroka"
                @change="promijeniOznaku"
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-select v-model="f.evidencija.primjena139" :items="['da', 'ne', '']" label="Primjena čl. 139. i 141." dense></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                :value="f.netoPoSatu"
                label="Satni iznos osnovice (eura)"
                hint="= neto po satu iz točke 3; mijenja se samo tamo"
                persistent-hint
                readonly
                dense
                filled
              ></v-text-field>
            </v-col>
          </v-row>
          <div style="overflow-x: auto;">
            <table class="r1-tablica">
              <thead>
                <tr>
                  <th>Datum isplate</th><th>Isplata za vrijeme od</th><th>do</th><th>Broj dana</th><th>Broj sati</th>
                  <th>% od osnovice</th><th>Satni iznos naknade</th><th>Iznos eura</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in f.evidencija.isplate" :key="'e' + i">
                  <td v-for="k in KOLONE_ISPLATE" :key="k">
                    <input v-model="r[k]" :class="{lijevo: k === 'datum' || k === 'od' || k === 'do'}" @input="preracunajIsplatu(r, k)" />
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3"><b>Ukupno</b></td>
                  <td class="ukupno">{{ f.evidencija.ukupno.dani }}</td>
                  <td class="ukupno">{{ f.evidencija.ukupno.sati }}</td>
                  <td></td><td></td>
                  <td class="ukupno">{{ f.evidencija.ukupno.iznos }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="caption grey--text text--darken-1 mt-1">
            Satni iznos naknade = satni iznos osnovice x % / 100; iznos = sati x satni iznos naknade (oba su uredivi).
            Zadani postotak je postavljen samo za A0 (70 %), B0 i C0 (100 %) - postotke potvrdi s računovodstvom/HZZO-om.
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Zatvori</v-btn>
        <v-btn color="primary" :disabled="!f" @click="ispis">Ispis / PDF</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs'
import SalarieService from '@/services/SalarieService'
import { printPotvrdaOPlaciPdf, eur, sati, num } from './potvrdaOPlaciPdf'

const KOLONE_ISPLATE = ['datum', 'od', 'do', 'dani', 'sati', 'posto', 'satni', 'iznos']
const ZADANI_POSTOCI = { A0: 70, B0: 100, C0: 100 }
const OZNAKE = [
  ['A0', 'Bolest'], ['A1', 'Transplantacija u korist druge osigurane osobe'], ['B0', 'Ozljeda na radu'],
  ['C0', 'Profesionalna bolest'], ['D1', 'Izolacija kliconoše'], ['D2', 'Izolacija zbog zaraze u okolini'],
  ['DR', 'Posljedica sudjelovanja u Domovinskom ratu'], ['E0', 'Pratnja'],
  ['F6', 'Njega člana obitelji - do sedme godine djeteta'], ['F3', 'Njega člana obitelji - od sedme do 18. godine djeteta'],
  ['F5', 'Njega člana obitelji - od 18. godine djeteta i njega supružnika / životnog partnera'],
  ['G0', 'Komplikacije u vezi trudnoće i poroda'], ['H1', 'Rodiljni dopust']
].map(o => ({ oznaka: o[0], tekst: o[0] + ' - ' + o[1] }))
const KOLONE = ['mjesec', 'placa', 'isplacena', 'satiPuno', 'satiDuze', 'satiOdsutnost', 'satiUkupno', 'satiPN', 'satiKalendar']
const ZBROJ = ['placa', 'isplacena', 'satiPuno', 'satiDuze', 'satiOdsutnost', 'satiUkupno', 'satiPN', 'satiKalendar']
const NOVAC = ['placa', 'isplacena']

// 'YYYY-MM-DD' -> 'DD.MM.YYYY.'
const datumHR = (d) => {
  const x = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ''))
  return x ? x[3] + '.' + x[2] + '.' + x[1] + '.' : ''
}

export default {
  name: 'potvrdaoplacidialog',
  props: {
    value: { type: Boolean, default: false },
    employee: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      KOLONE,
      KOLONE_ISPLATE,
      OZNAKE,
      mjesec: dayjs().format('YYYY-MM'),
      mjesecIsplate: dayjs().format('YYYY-MM'),
      info: null,
      f: null,
      upozorenja: [],
      ucitavam: false,
      greska: ''
    }
  },
  computed: {
    imeRadnika () {
      return [this.employee.First, this.employee.Last].filter(Boolean).join(' ')
    }
  },
  watch: {
    value (otvoren) {
      if (otvoren) { this.ucitaj() }
    },
    // satni iznos osnovice je izveden iz neto po satu (tocka 3) - svaka promjena se prepisuje
    'f.netoPoSatu' () {
      if (this.f && this.f.evidencija) {
        this.f.evidencija.isplate.forEach(r => this.preracunajIsplatu(r, 'posto'))
        this.zbrojiIsplate()
      }
    },
    // Vuetify v-text-field salje "change" tek kad polje izgubi fokus, pa odabir mjeseca iz pickera
    // nije osvjezavao podatke. Ucitavanje zato ide na svaku promjenu vrijednosti.
    mjesec (novi) {
      if (/^\d{4}-(0[1-9]|1[0-2])$/.test(novi || '') && this.value) { this.ucitaj() }
    }
  },
  mounted () {
    if (this.value) { this.ucitaj() }
  },
  methods: {
    async ucitaj (samoEvidencija) {
      samoEvidencija = samoEvidencija === true
      this.greska = ''
      if (!this.mjesec || !this.employee.id) { return }
      // Brojac zahtjeva: ako se mjesec promijeni dok prethodni upit jos traje, spor stariji odgovor se odbacuje
      // (inace bi prepisao podatke za noviji mjesec).
      this.zahtjev = (this.zahtjev || 0) + 1
      const moj = this.zahtjev
      const trazeniMjesec = this.mjesec
      this.ucitavam = true
      try {
        const res = await SalarieService.r1({
          CompanyId: this.$store.state.companyid,
          EmployeeId: this.employee.id,
          mjesec: trazeniMjesec,
          mjesecIsplate: this.mjesecIsplate
        })
        if (moj !== this.zahtjev) { return }
        if (samoEvidencija && this.f) {
          // promjena mjeseca isplate ne dira ostale izmjene u formi
          this.info = res.data.evidencijskiList
          this.predpopuniIsplate()
        } else {
          this.popuni(res.data)
        }
      } catch (err) {
        if (moj !== this.zahtjev) { return }
        this.f = null
        const poruke = err && err.response && err.response.data && err.response.data.errors
        this.greska = poruke ? poruke.join(' ') : 'Podaci se ne mogu učitati.'
      }
      if (moj === this.zahtjev) { this.ucitavam = false }
    },
    popuni (d) {
      const o = d.osiguranik || {}
      const p = d.poslodavac || {}
      const redci = (d.redci || []).map(r => ({
        oznaka: r.oznaka,
        mjesec: r.imaIsplatu ? r.oznaka : '',
        placa: eur(r.placa),
        isplacena: eur(r.isplacena),
        satiPuno: sati(r.satiPuno),
        satiDuze: sati(r.satiDuze),
        satiOdsutnost: sati(r.satiOdsutnost),
        satiUkupno: sati(r.satiUkupno),
        satiPN: sati(r.satiPN),
        satiKalendar: sati(r.satiKalendar)
      }))
      this.upozorenja = d.upozorenja || []
      this.f = {
        poslodavac: [p.naziv, p.adresa, p.oib ? 'OIB: ' + p.oib : ''].filter(Boolean).join(', '),
        brojObveze: '',
        prezime: o.prezime || '',
        ime: o.ime || '',
        datumRodenja: datumHR(o.datumRodenja),
        oib: o.oib || '',
        mbo: o.mbo || '',
        drugiStup: d.drugiStup ? 'da' : 'ne',
        razdobljeOd: datumHR(d.razdoblje.od),
        razdobljeDo: datumHR(d.razdoblje.do),
        redci,
        ukupno: {},
        brutoPoSatu: d.brutoPoSatu === null ? '' : eur(d.brutoPoSatu, 4),
        netoPoSatu: d.netoPoSatu === null ? '' : eur(d.netoPoSatu, 4),
        mjesto: p.mjesto || '',
        datum: dayjs().format('DD.MM.YYYY.'),
        ovlastenaOsoba: p.ovlastenaOsoba || '',
        evidencija: {
          datumPocetka: '',
          prviDan: '',
          posljednjiDan: '',
          brojEvidencije: '',
          vrstaPN: 'PN',
          brojOzljede: '',
          vrstaOzljede: '',
          // pretpostavka: bolest; promijeni po potrebi (postotak se veze uz oznaku)
          oznaka: 'A0',
          primjena139: '',
          isplate: [0, 1, 2, 3, 4].map(() => ({ datum: '', od: '', do: '', dani: '', sati: '', posto: '', satni: '', iznos: '' })),
          ukupno: { dani: '', sati: '', iznos: '' }
        }
      }
      this.info = d.evidencijskiList || null
      this.zbroji()
      this.predpopuniIsplate()
    },
    // prvi redak: sati bolovanja na teret Zavoda iz obracuna za mjesec isplate (datumi nisu u bazi)
    predpopuniIsplate () {
      const rows = this.f.evidencija.isplate
      rows.forEach(r => { r.datum = ''; r.od = ''; r.do = ''; r.dani = ''; r.sati = ''; r.posto = ''; r.satni = ''; r.iznos = '' })
      const i = this.info
      if (i && i.satiZavod > 0) {
        const r = rows[0]
        r.sati = sati(i.satiZavod)
        r.dani = sati(i.daniZavod)
        const z = ZADANI_POSTOCI[this.f.evidencija.oznaka]
        r.posto = z !== undefined ? String(z) : ''
        this.preracunajIsplatu(r, 'posto')
      }
      this.zbrojiIsplate()
    },
    // promjena oznake uzroka: postotak se mijenja samo u redcima gdje je prazan ili je bio zadani
    promijeniOznaku (nova) {
      const zadani = Object.keys(ZADANI_POSTOCI).map(k => String(ZADANI_POSTOCI[k]))
      this.f.evidencija.isplate.forEach(r => {
        if (r.posto === '' || zadani.indexOf(String(r.posto)) !== -1) {
          r.posto = ZADANI_POSTOCI[nova] !== undefined ? String(ZADANI_POSTOCI[nova]) : ''
          this.preracunajIsplatu(r, 'posto')
        }
      })
      this.zbrojiIsplate()
    },
    // satni iznos naknade = osnovica x % / 100 (4 dec.), iznos = sati x satni iznos (2 dec.)
    preracunajIsplatu (r, kolona) {
      const osnovica = num(this.f.netoPoSatu)
      if (kolona === 'sati' || kolona === 'posto') {
        const posto = num(r.posto)
        if (osnovica === null || posto === null) {
          r.satni = ''
        } else {
          r.satni = eur(Math.round(osnovica * posto / 100 * 10000) / 10000, 4)
        }
      }
      if (kolona === 'sati' || kolona === 'posto' || kolona === 'satni') {
        const sat = num(r.sati)
        const sat2 = num(r.satni)
        r.iznos = sat === null || sat2 === null ? '' : eur(Math.round(sat * sat2 * 100) / 100)
      }
      if (kolona !== 'datum' && kolona !== 'od' && kolona !== 'do') { this.zbrojiIsplate() }
    },
    zbrojiIsplate () {
      const rows = this.f.evidencija.isplate
      const zb = k => rows.reduce((a, r) => a + (num(r[k]) || 0), 0)
      const d = zb('dani')
      const sa = zb('sati')
      const iz = zb('iznos')
      this.f.evidencija.ukupno = { dani: d ? sati(d) : '', sati: sa ? sati(sa) : '', iznos: iz ? eur(iz) : '' }
    },
    // zbroj stupaca iz redaka; stupac 7 se racuna iz 4 + 5 + 6 kad se mijenja neki od njih
    preracunaj (kolona) {
      if (['satiPuno', 'satiDuze', 'satiOdsutnost'].indexOf(kolona) !== -1) {
        this.f.redci.forEach(r => {
          const s = (num(r.satiPuno) || 0) + (num(r.satiDuze) || 0) + (num(r.satiOdsutnost) || 0)
          r.satiUkupno = s ? sati(s) : ''
        })
      }
      // stupac 9 je zadano jednak stupcu 7 (i dalje se moze rucno ispraviti)
      if (['satiPuno', 'satiDuze', 'satiOdsutnost', 'satiUkupno'].indexOf(kolona) !== -1) {
        this.f.redci.forEach(r => { r.satiKalendar = r.satiUkupno })
      }
      this.zbroji()
    },
    zbroji () {
      const u = {}
      ZBROJ.forEach(k => {
        const s = this.f.redci.reduce((a, r) => a + (num(r[k]) || 0), 0)
        u[k] = NOVAC.indexOf(k) !== -1 ? eur(s) : sati(s)
      })
      this.f.ukupno = u
    },
    preracunajSatnicu () {
      const s = num(this.f.ukupno.satiUkupno) || 0
      if (!s) {
        this.f.brutoPoSatu = ''
        this.f.netoPoSatu = ''
        return
      }
      this.f.brutoPoSatu = eur((num(this.f.ukupno.placa) || 0) / s, 4)
      this.f.netoPoSatu = eur((num(this.f.ukupno.isplacena) || 0) / s, 4)
    },
    ispis () {
      printPotvrdaOPlaciPdf(this.f)
    }
  }
}
</script>

<style scoped>
.naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1565c0;
  padding: 3px 8px;
  margin-bottom: 16px;
  line-height: 1.5;
}
.r1-tablica {
  width: 100%;
  border-collapse: collapse;
}
.r1-tablica th {
  font-size: 12px;
  text-align: center;
  padding: 4px;
  border: 1px solid #999;
}
.r1-tablica td {
  border: 1px solid #bbb;
  padding: 0;
}
.r1-tablica input {
  width: 100%;
  text-align: right;
  padding: 5px 6px;
  font-size: 14px;
  outline: none;
}
.r1-tablica input.lijevo {
  text-align: center;
}
.r1-tablica input:focus {
  background: #eef4fb;
}
.r1-tablica .ukupno {
  text-align: right;
  font-weight: 700;
  padding: 5px 6px;
}
</style>
